export const LOCAL_STORAGE_AUTH_TOKEN = 'auth:access_token'

export const COOKIE_AUTH_TOKEN = 'clinic-portal-token'

export const COOKIE_REFRESH_TOKEN = 'clinic-portal-refresh-token'

export const COOKIE_EXPIRES_TOKEN = 'expires-token'

export const FORMAT_DATE_DAYJS = 'MMM DD, YYYY HH:mm'

export const FORMAT_DATE = 'MMM DD, YYYY'

export const FORMAT_DATE_TIME_DAYJS = 'YYYY-MM-DD HH:mm:ss'

export const FORMAT_DATE_DAYJS_API = 'YYYY-MM-DD'

export const FORMAT_TIME = 'HH:mm'

export const REMEMBER_LOGIN = 'rememberLogin'

export enum RES_STATUS {
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL'
}

export enum ERROR_CODE {
  SUCCESS = '0000',
  FAIL_0403 = '0403',
  TOKEN_EXPIRED = '0205',
  TOKEN_INVALID = '0200',
  TOKEN_BANNED = '0202'
}

export const ERROR_CODE_RE_LOGIN = [
  ERROR_CODE.TOKEN_BANNED,
  ERROR_CODE.TOKEN_INVALID,
  ERROR_CODE.TOKEN_EXPIRED
]

export const responseMessage = {
  [RES_STATUS.FAIL]: 'Sorry, something went wrong.',
  403: 'Sorry, you are not authorized to access this page.',
  404: 'Sorry, the page you visited does not exist.',
  500: 'Sorry, something went wrong.'
}

export enum sort {
  descend = 'DESC',
  ascend = 'ASC'
}

export const PAGE_SIZE_OPTIONS = [
  { value: 10, label: 10 },
  { value: 20, label: 20 },
  { value: 30, label: 30 },
  { value: 50, label: 50 },
  { value: 100, label: 100 }
]

export const PAGE_SIZE_OPTION_ALL = {
  value: 10000000,
  label: 'all'
}

export const default_page_size = 10
export const DEFAULT_CURRENT_PAGE = 1

export const TIME_DELAY_FALLBACK = 0

export const NO_DATA = '--'

export const DEBOUNCE_TIME = 500
